import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { InternationalizationService } from './internationalization.service';

@Injectable()
export class CustomTranslationHttpLoader implements TranslateLoader {
  constructor(
    private internationalizationService: InternationalizationService
  ) {}

  getTranslation(lang: string) {
    return this.internationalizationService.getTranslations(lang).pipe(
      map(
        (translationGetResponseEnvelope: any) => translationGetResponseEnvelope
      ),
      catchError(() => {
        const subject = new Subject<{ [key: string]: string }>();
        fetch(`/assets/i18n/${lang}.json`)
          .then((res) => res.json())
          .then((translations: { [key: string]: string }) => {
            subject.next(translations);
            subject.complete();
          });
        return subject;
      })
    );
  }
}
